import { render, staticRenderFns } from "./ChangePasswordForm.vue?vue&type=template&id=613be30c&scoped=true"
import script from "./ChangePasswordForm.ts?vue&type=script&lang=ts&external"
export * from "./ChangePasswordForm.ts?vue&type=script&lang=ts&external"
import style0 from "./ChangePasswordForm.vue?vue&type=style&index=0&id=613be30c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613be30c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('613be30c')) {
      api.createRecord('613be30c', component.options)
    } else {
      api.reload('613be30c', component.options)
    }
    module.hot.accept("./ChangePasswordForm.vue?vue&type=template&id=613be30c&scoped=true", function () {
      api.rerender('613be30c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Auth/components/ChangePasswordForm/ChangePasswordForm.vue"
export default component.exports